import type { ChartOptions } from 'chart.js';

import { commonChartOptions } from './common-chart-options';

export const DEFAULT_BAR_CHART_OPTIONS: ChartOptions<'bar'> = {
  events: ['mouseleave', 'mousemove', 'click'],
  animation: {
    duration: 200,
  },
  responsive: true,
  maintainAspectRatio: false,
  onHover: commonChartOptions.onHoverCursorOption,
  plugins: {
    legend: {
      labels: commonChartOptions.legendOption.labels,
    },
  },
};

export const DEFAULT_LINE_CHART_OPTIONS: ChartOptions<'line'> = {
  events: ['mousemove', 'click'],
  animation: false,
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      labels: commonChartOptions.legendOption.labels,
    },
  },
};

export const DEFAULT_PIE_CHART_OPTIONS: ChartOptions<'doughnut'> = {
  events: ['mouseleave', 'mousemove', 'click'],
  animation: {
    duration: 200,
  },
  responsive: true,
  maintainAspectRatio: false,
  onHover: commonChartOptions.onHoverCursorOption,
  plugins: {
    legend: {
      labels: commonChartOptions.legendOption.labels,
    },
  },
};
